import { Navigate } from "react-router-dom";
import React from "react";

const PrivateRoute = ({ children, token }) => {
  return token ? children : <Navigate to="/signin" />;
};

export default PrivateRoute;
